// 考试报名 报名信息
export const SIGNUP_MSG = ()=>import('@/page/signUp/message.vue')
// 报名信息详情
export const SIGNUP_DETAIL = ()=>import('@/page/signUp/detail.vue')
// 列表
export const SIGNUP_LIST = () =>import('@/page/signUp/signList.vue')
// 选择地区
export const CHOOSE_REGION = ()=>import('@/page/signUp/chooseRegion.vue')
// 验证信息
// export const CHECK_UP =() =>import('@/page/signUp/checkup.vue')


// WEBPACK FOOTER //
// ./src/router/signup.js